<template>
    <a class="lrg-btn" @click="$emit('click')">
        <span key="join">{{ text }}</span>
    </a>
</template>

<script>
export default {
    name: 'LargeButton',
    props: ['text']
}
</script>

<style lang="scss" scoped>
a {

}
a.lrg-btn {
    transition: all 0.2s ease;
    transition-property: box-shadow, color, background-color;

    font-size: 4vh;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    color: var(--main-color);
    background-color: var(--other-color);

    padding: 3vh;
    margin: 0 3vw 6vh 3vw;
    text-decoration: none;
    display: inline-block;
    border: none;
    border-radius: 1.5vh;
    box-shadow: 0 0 0 2px var(--main-color);

    &:hover {
        color: var(--other-color);
        background-color: var(--theme-color);
        box-shadow: 0 0 8px 0px var(--theme-color);
    }
}
</style>